module.exports = __webpack_public_path__ + "img/renseignement.9ab93376.svg";